import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'map-north', 'MapNorth', [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}],["path",{"d":"M10 15v-6l4 6v-6"}]]);